import { AnimatePresence, motion } from 'framer-motion';
import { cn } from '@/Domain/utils/cn';

interface FieldMessageProps {
  error?: string;
  hint?: string;
}

// Reserves one line of vertical space so an error/hint toggling never re-flows
// the vertically-centered auth card. The message itself crossfades in and out.
export const FieldMessage = ({ error, hint }: FieldMessageProps) => {
  const message = error ?? hint;

  return (
    <div className="min-h-5">
      <AnimatePresence mode="wait" initial={false}>
        {message && (
          <motion.p
            key={error ? `error:${error}` : `hint:${hint}`}
            initial={{ opacity: 0, y: -3 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -3 }}
            transition={{ duration: 0.15, ease: 'easeOut' }}
            className={cn(error ? 'text-sm text-destructive' : 'text-xs text-muted-foreground')}
          >
            {message}
          </motion.p>
        )}
      </AnimatePresence>
    </div>
  );
};
